// referenced from confluence/next/packages/error-boundary/src/ErrorComponent.tsx

import { defineMessages } from 'react-intl';

export const i18n: {
	actionReloadPage: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	description: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	title: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	code: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	url: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	supportLinkText: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	actionReloadPage: {
		id: 'error-boundary.reload-page',
		description: 'The button/link which triggers a refresh/reload of the current page',
		defaultMessage: 'Refresh page',
	},
	description: {
		id: 'error-boundary.description',
		description:
			"Additional text shown when displaying a technical error. {atlassianSupportLink} will be substituted with a message that has id='error-boundary.support-link-text' which reads as 'our support team'. This phrase continues with a list of bullet points",
		defaultMessage:
			'The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:',
	},
	title: {
		id: 'error-boundary.title',
		description: 'Title shown when displaying a technical error',
		defaultMessage: "We've hit a snag",
	},
	code: {
		id: 'error-boundary.code',
		description:
			'The code field in error boundary component {code} will be substituted with a string of digits and letters.',
		defaultMessage: 'The code associated with this error: {code}',
	},
	url: {
		id: 'error-boundary.url',
		description: 'The url field in error boundary component',
		defaultMessage: 'The URL of this page',
	},
	supportLinkText: {
		id: 'error-boundary.support-link-text',
		description: 'The text of the link which will lead the user to the Atlassian Support web site',
		defaultMessage: 'our support team',
	},
});
